import { colors } from '@mui/material';
import { softShadows } from './shadows';
import { THEMES } from '../constants';
import typography from './typography';

// Old MUI 4 config. Rather make theme changes in the ../v5 directory
export const themeConfigV4 = [
  {
    name: THEMES.LIGHT,
    direction: 'ltr',
    typography,

    overrides: {
      MuiInputBase: {
        input: {
          '&::placeholder': {
            opacity: 1,
            color: colors.blueGrey[600],
          },
        },
      },
      MuiLinearProgress: {
        root: {
          borderRadius: 3,
          overflow: 'hidden',
        },
      },
      MuiListItemIcon: {
        root: {
          minWidth: 32,
        },
      },
    },

    breakpoints: {
      keys: ['xs', 'sm', 'md', 'lg', 'xl'],
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920,
      },
    },

    palette: {
      mode: 'light',
      action: {
        active: colors.blueGrey[600],
      },
      background: {
        default: colors.common.white,
        dark: '#f4f6f8',
        paper: colors.common.white,
      },
      primary: {
        main: colors.indigo[600],
      },
      secondary: {
        main: '#5850EC',
      },
      text: {
        primary: colors.blueGrey[900],
        secondary: colors.blueGrey[600],
        hint: 'rgba(0, 0, 0, 0.38)',
      },
    },
    shadows: softShadows,
  },
];
